
import React from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Loader2, AlertTriangle, ShieldAlert } from "lucide-react";
import StripeIntegrationInfo from './StripeIntegrationInfo';
import StripeConnectionButton from './StripeConnectionButton';
import StripeConnectionStatus from './StripeConnectionStatus';
import { useStripeConnection } from '@/hooks/useStripeConnection';
import { useStripeStatus } from '@/hooks/useStripeStatus';
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import AchFeeSettings from '@/components/SettingsTabs/AchFeeSettings';

const PaymentIntegrationSettings: React.FC = () => {
  const { 
    isConnected, 
    accountId, 
    isConnecting,
    configError, 
    handleConnect, 
    handleDisconnect 
  } = useStripeConnection();
  
  const { isLoading, error } = useStripeStatus();
  
  if (isLoading) {
    return (
      <div className="space-y-6">
        <h2 className="text-xl font-semibold mb-6">Payment Integration</h2>
        
        <Card>
          <CardContent className="p-6">
            <div className="flex flex-col items-center justify-center py-8">
              <Loader2 className="h-8 w-8 animate-spin text-keepmore-purple mb-4" />
              <p className="text-gray-500">Checking Stripe connection status...</p>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }
  
  if (error || configError) {
    const displayError = error || configError;
    
    return (
      <div className="space-y-6">
        <h2 className="text-xl font-semibold mb-6">Payment Integration</h2>
        
        <Card>
          <CardContent className="p-6">
            <div className="flex flex-col items-center justify-center py-8">
              <AlertTriangle className="h-8 w-8 text-amber-500 mb-4" />
              <h3 className="text-lg font-medium mb-2">Configuration Error</h3>
              <p className="text-gray-500 text-center mb-4">{displayError}</p>
              
              {displayError && displayError.includes('STRIPE_CLIENT_ID') ? (
                <Alert variant="destructive" className="mt-4">
                  <ShieldAlert className="h-4 w-4" />
                  <AlertTitle>Missing Stripe Client ID</AlertTitle>
                  <AlertDescription>
                    You need to add your STRIPE_CLIENT_ID to your Supabase Edge Function secrets. 
                    You can find your Client ID in the Stripe Dashboard under Settings &gt; Connect settings.
                  </AlertDescription>
                </Alert>
              ) : (
                <p className="text-sm text-gray-400 text-center">
                  Make sure you have set up the STRIPE_CLIENT_ID and STRIPE_SECRET_KEY in your Supabase Edge Function secrets.
                </p>
              )}
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }
  
  return (
     <div className="space-y-6">
      {/* <h2 className="text-xl font-semibold mb-6">Payment Integration</h2> */}
      
      <Card>
        <CardContent className="p-6">
          {!isConnected ? (
            <StripeConnectionButton
              isConnecting={isConnecting}
              onConnect={handleConnect}
            />
          ) : (
            <StripeConnectionStatus
              isConnected={isConnected}
              accountId={accountId}
              isConnecting={isConnecting}
              onDisconnect={handleDisconnect}
            />
          )}
        </CardContent>
      </Card>
      
      {isConnected && <StripeIntegrationInfo />}
  {/*       
        <Card>
          <CardHeader>
            <CardTitle>Payment Fee Settings</CardTitle>
            <CardDescription>Configure how transaction fees are handled</CardDescription>
          </CardHeader>
          <CardContent className="p-6">
            <AchFeeSettings />
          </CardContent>
        </Card> */}
    </div>
  );
};

export default PaymentIntegrationSettings;
